import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Editor from './Editor';
import 'suneditor/dist/css/suneditor.min.css';

const HotelEvent = () => {
  const [themeColor, setThemeColor] = useState<number>(0); // 0: white, 1: black
  const [editText, setEditText] = useState<string>('');

  useEffect(() => {
    console.log('editText', editText);
  }, [editText]);

  return (
    <>
      <Style>
        <div className={`contentContainer ${themeColor === 1 && 'black'}`}>
          <div className="inputText">
            <div className="title initial">
              <h4>호텔 이벤트</h4>
            </div>
            {/* <div className="row">
              <h5>배경색</h5>
              <button
                className={`${themeColor === 0 && 'active'}`}
                onClick={() => setThemeColor(0)}>
                <div className="block white" />
              </button>
              <button
                className={`${themeColor === 1 && 'active'}`}
                onClick={() => setThemeColor(1)}>
                <div className="block black" />
              </button>
            </div> */}
            <Editor editText={editText} setEditText={setEditText} />
            <div className="title">
              <h4>미리보기</h4>
            </div>
            <div
              className="sun-editor-editable preview"
              dangerouslySetInnerHTML={{ __html: editText }}
            />
            <button className={`submitButton`}>등록</button>
          </div>
        </div>
      </Style>
    </>
  );
};

export default HotelEvent;

const Style = styled.div`
  @font-face {
    font-family: '고운 돋음';
    src: url('${process.env.PUBLIC_URL}/font/Dodum-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: '고운 바탕';
    src: url('${process.env.PUBLIC_URL}/font/Batang-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'G마켓 산스';
    src: url('${process.env.PUBLIC_URL}/font/GmarketSansTTF.ttf') format('truetype');
  }
  @font-face {
    font-family: '청주김생체';
    src: url('${process.env.PUBLIC_URL}/font/ChungjuKimSaeng.ttf') format('truetype');
  }
  @font-face {
    font-family: '여기어때 잘난체';
    src: url('${process.env.PUBLIC_URL}/font/Jalnan2TTF.ttf') format('truetype');
  }

  .row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0 6px;
    h5 {
      color: #555;
    }
    button {
      padding: 4px;
      border-radius: 3px;
      border: 1px solid #dadada;
      background: #fafafa;
      .block {
        width: 24px;
        height: 24px;
        border-radius: 3px;
        background: #fff;
      }
      .block.black {
        background: #000;
      }
    }
    button:hover {
      background: #e1e1e1;
      border-color: #d1d1d1;
    }
    button.active {
      background: #4dd2ae;
      border-color: #4dd2ae;
    }
  }

  .inputText {
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
      }
      h4 {
        color: #555555;
      }
    }

    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .preview {
    width: 100%;
    height: 30vh;
    padding: 20px;
    border: 1px solid #dadada;
    overflow: auto;
  }

  .black {
    .sun-editor-editable,
    .preview {
      border: 1px solid #cecece;
      background-color: #000;
      color: #fff;

      hr {
        border-color: #fff;
      }

      thead {
        border-bottom: 2px solid #fff;
      }
      tr,
      td,
      th {
        border: 1px solid #fff !important;
      }
      th {
        background-color: #555;
      }
    }
  }
`;
